import { render, staticRenderFns } from "./sub-request-type-card.vue?vue&type=template&id=bb982172&scoped=true&"
import script from "./sub-request-type-card.vue?vue&type=script&lang=js&"
export * from "./sub-request-type-card.vue?vue&type=script&lang=js&"
import style0 from "./sub-request-type-card.vue?vue&type=style&index=0&id=bb982172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb982172",
  null
  
)

export default component.exports